<template>
    <div class="ClientConsulting">
        <div class="ClientConsulting_left">
            <div class="ClientConsulting_left_top">
                <p>当前咨询师</p>
                <img src="../../assets/20220421181528.png" alt="">
                <span>咨询师名字</span>
                <i>二级咨询师</i>
            </div>
            <div class="ClientConsulting_left_botton">
                <h3>查找其他咨询师</h3>
                <input v-model="taocan" type="text" placeholder="输入咨询师名字">
                <ul>
                    <li v-for="item in ZiXunShi" :key="item.index" @click="Thequery(item.UserID)"> {{item.RealName}}
                    </li>
                </ul>
            </div>
        </div>
        <el-dialog title="填写预约表单" :visible.sync="dialogVisible" width="720px" :before-close="handleClose" center>
            <div class="boxs">
                <el-form :model="from" label-width="80px">
                    <el-form-item disabled="true" label-width="260px" label="保密原则告知和解释（书面和口头）" prop="AnswerName1">
                        <el-radio-group v-model="AnswerName1">
                            <el-radio label="0">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item class="cscklkl" prop="ConsultType">
                        <p>咨询方式(必填)：</p>
                        <el-select v-model="from.ConsultType " placeholder="请选择咨询方式">
                            <el-option label="面对面咨询" value="0"></el-option>
                            <el-option label="视频咨询" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="cscklkl" prop="SchedulingDate">
                        <p>排班日期(必填)：</p>
                        <el-date-picker v-model="from.SchedulingDate " type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item class="cscklkl" prop="Mobile">
                        <p>本人联系方式(必填)：</p>
                        <el-input v-model="from.Mobile "></el-input>
                    </el-form-item>
                    <el-form-item class="cscklkl" prop="EmergentMobile">
                        <p>紧急联系方式(必填)：</p>
                        <el-input v-model="from.EmergentMobile "></el-input>
                    </el-form-item>
                    <el-form-item class="ConsultCntIntroduce" prop="ConsultCntIntroduce">
                        <p>来询问题(必填)：</p>
                        <el-input type="textarea" v-model="from.ConsultCntIntroduce "></el-input>
                    </el-form-item>
                    <el-form-item class="ConsultCntIntroduce" prop="FamilyStatus">
                        <p>家庭情况：</p>
                        <el-select v-model="from.FamilyStatus " placeholder="请选择家庭情况">
                            <el-option label="原生家庭" value="0"></el-option>
                            <el-option label="丧亲" value="1"></el-option>
                            <el-option label="离异" value="2"></el-option>
                            <el-option label="再组家庭" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="cscklkltextarea" prop="SymptomPerformance">
                        <p>症状表现</p>
                        <el-input type="textarea" v-model="from.SymptomPerformance "></el-input>
                    </el-form-item>
                    <el-form-item class="cscklkltextarea" prop="PhysicalCondition">
                        <p>躯体情况：</p>
                        <el-input type="textarea" v-model="from.PhysicalCondition "></el-input>
                    </el-form-item>
                    <el-form-item class="cscklkltextarea" prop="ConsultingHistory">
                        <p>咨询历史：</p>
                        <el-input type="textarea" v-model="from.ConsultingHistory "></el-input>
                    </el-form-item>
                    <el-form-item class="cscklkltextarea" prop="PsychologicalTest">
                        <p>心理测试：</p>
                        <el-input type="textarea" v-model="from.PsychologicalTest "></el-input>
                    </el-form-item>
                    <el-form-item class="cscklkltextarea" prop="SymptomsOften">
                        <p>症状时长：</p>
                        <el-input type="textarea" v-model="from.SymptomsOften "></el-input>
                    </el-form-item>
                    <el-form-item class="cscklkltextarea zui" prop="Remarks">
                        <p>备注：</p>
                        <el-input type="textarea" v-model="from.Remarks "></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-button @click="tijiao('ruleForm')" class="wbutton" type="primary">下一步</el-button>
        </el-dialog>
        <div class="ClientConsulting_right">
            <ul class="ClientConsulting_right_top">
                <li v-for="item in paiban" :key="item.index">
                    <p>{{item.DateS}}</p>
                    <p>{{item.Days}}</p>
                </li>
            </ul>
            <ul class="ClientConsulting_right_ul">
                <li>
                    <ul v-if="paiban[0]">
                        <li v-for="items in paiban[0].ZhanTimes" :key="items.index">
                            {{items.StartTime}}-{{items.FinishTime}}
                            <p v-if="items.States == 4"
                                @click="dialogVisibles(items.SchedulID,items.ConsultSchID,items.SchedulYM )">点击预约</p>
                            <p v-else-if="items.States == 1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                            <p v-else-if="items.States == -1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                            <p v-else-if="items.States == 2"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                            <p v-else-if="items.States == 3">已预约</p>
                            <p v-else-if="items.States == 5"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师取消</p>
                            <i v-if="items.States == 3">已预约<span
                                    @click="wcancel(items.ConsultSchID,items.AppointmentID)">取消预约</span></i>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul v-if="paiban[1]">
                        <li v-for="items1 in paiban[1].ZhanTimes" :key="items1.index">
                            {{items1.StartTime}}-{{items1.FinishTime}}
                            <p v-if="items1.States == 4"
                                @click="dialogVisibles(items1.SchedulID,items1.ConsultSchID,items1.SchedulYM )">点击预约</p>
                            <p v-else-if="items1.States == 1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                            <p v-else-if="items1.States == -1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                            <p v-else-if="items1.States == 2"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                            <p v-else-if="items1.States == 3">已预约</p>
                            <p v-else-if="items1.States == 5"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师取消</p>
                            <i v-if="items1.States == 3">已预约<span
                                    @click="wcancel(items1.ConsultSchID,items1.AppointmentID)">取消预约</span></i>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul v-if="paiban[2]">
                        <li v-for="items2 in paiban[2].ZhanTimes" :key="items2.index">
                            {{items2.StartTime}}-{{items2.FinishTime}}
                            <p v-if="items2.States == 4"
                                @click="dialogVisibles(items2.SchedulID,items2.ConsultSchID,items2.SchedulYM )">点击预约</p>
                            <p v-else-if="items2.States == 1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                            <p v-else-if="items2.States == -1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                            <p v-else-if="items2.States == 2"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                            <p v-else-if="items2.States == 3">已预约</p>
                            <p v-else-if="items2.States == 5"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师取消</p>
                            <i v-if="items2.States == 3">已预约<span
                                    @click="wcancel(items2.ConsultSchID,items2.AppointmentID)">取消预约</span></i>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul v-if="paiban[3]">
                        <li v-for="items3 in paiban[3].ZhanTimes" :key="items3.index">
                            {{items3.StartTime}}-{{items3.FinishTime}}
                            <p v-if="items3.States == 4"
                                @click="dialogVisibles(items3.SchedulID,items3.ConsultSchID,items3.SchedulYM )">点击预约</p>
                            <p v-else-if="items3.States == 1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                            <p v-else-if="items3.States == -1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                            <p v-else-if="items3.States == 2"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                            <p v-else-if="items3.States == 3">已预约</p>
                            <p v-else-if="items3.States == 5"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师取消</p>
                            <i v-if="items3.States == 3">已预约<span
                                    @click="wcancel(items3.ConsultSchID,items3.AppointmentID)">取消预约</span></i>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul v-if="paiban[4]">
                        <li v-for="items4 in paiban[4].ZhanTimes" :key="items4.index">
                            {{items4.StartTime}}
                            <p v-if="items4.States == 4"
                                @click="dialogVisibles(items4.SchedulID,items4.ConsultSchID,items4.SchedulYM )">点击预约</p>
                            <p v-else-if="items4.States == 1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                            <p v-else-if="items4.States == -1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                            <p v-else-if="items4.States == 2"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                            <p v-else-if="items4.States == 3">已预约</p>
                            <p v-else-if="items4.States == 5"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师取消</p>
                            <i v-if="items4.States == 3">已预约<span
                                    @click="wcancel(items4.ConsultSchID,items4.AppointmentID)">取消预约</span></i>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul v-if="paiban[5]">
                        <li v-for="items5 in paiban[5].ZhanTimes" :key="items5.index">
                            {{items5.StartTime}}-{{items5.FinishTime}}
                            <p v-if="items5.States == 4"
                                @click="dialogVisibles(items5.SchedulID,items5.ConsultSchID,items5.SchedulYM )">点击预约</p>
                            <p v-else-if="items5.States == 1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                            <p v-else-if="items5.States == -1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                            <p v-else-if="items5.States == 2"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                            <p v-else-if="items5.States == 3">已预约</p>
                            <p v-else-if="items5.States == 5"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师取消</p>
                            <i v-if="items5.States == 3">已预约<span
                                    @click="wcancel(items5.ConsultSchID,items5.AppointmentID)">取消预约</span></i>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul v-if="paiban[6]">
                        <li v-for="items6 in paiban[6].ZhanTimes" :key="items6.index">
                            {{items6.StartTime}}-{{items6.FinishTime}}
                            <p v-if="items6.States == 4"
                                @click="dialogVisibles(items6.SchedulID,items6.ConsultSchID,items6.SchedulYM )">点击预约</p>
                            <p v-else-if="items6.States == 1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                            <p v-else-if="items6.States == -1"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                            <p v-else-if="items6.States == 2"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                            <p v-else-if="items6.States == 3">已预约</p>
                            <p v-else-if="items6.States == 5"
                                style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师取消</p>
                            <i v-if="items6.States == 3">已预约<span
                                    @click="wcancel(items6.ConsultSchID,items6.AppointmentID)">取消预约</span></i>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            AnswerName1: '',
            liActiveClass: 1,
            data: '',
            taocan: '',
            ZiXunShi: '',
            defaultZiXunShi: '',
            diandefaultZiXunShi: '',
            dialogVisible: false,
            paiban: [],
            from: {
                UserID: '',
                ConsultSchID: '',
                SchedulYM: '',
                ConsultType: '',
                SchedulingDate: '',
                Mobile: '',
                EmergentMobile: '',
                ConsultCntIntroduce: '',
                FamilyStatus: '',
                SymptomPerformance: '',
                PhysicalCondition: '',
                ConsultingHistory: '',
                PsychologicalTest: '',
                SymptomsOften: '',
                Remarks: '',
            },
        }
    },
    methods: {
        Thequery(val) {
            this.consulting(val, '');
            this.diandefaultZiXunShi = val;
        },
        keyDown(e) {
            //如果是回车则执行登录方法
            if (e.keyCode == 13) {
                if (this.taocan) {
                    this.loading(this.taocan)
                } else {
                    this.Global.request_failure("请输入搜索内容");
                }
            }
        },
        wcancel(res, wed) {
            debugger
            this.$confirm('此操作将取消预约, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var from = { "UserID": this.defaultZiXunShi, "ConsultSchID": res, "AppointmentID": wed }
                this.$Http_Post('ConsultSubscribe/UpdateAppointment', { "from": from }).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        this.Global.request_successful(res.Message);
                        if (this.diandefaultZiXunShi) {
                            this.consulting(this.diandefaultZiXunShi, '');
                        } else {
                            this.consulting(this.defaultZiXunShi, '');
                        }
                    } else {
                        this.Global.request_failure(res.Message)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            }
            );
        },
        dialogVisibles(val, ConsultSchID, SchedulYM) {
            this.from.UserID = this.defaultZiXunShi
            this.from.ConsultSchID = ConsultSchID
            this.from.SchedulYM = SchedulYM
            this.dialogVisible = true;
        },
        tijiao(formName) {
            if (!this.AnswerName1) {
                alert("请确定保密原则告知和解释（书面和口头）")
                return false
            }
            if (!this.from.ConsultType) {
                alert("请确定咨询方式")
                return false
            }
            if (!this.from.SchedulingDate) {
                alert("请确定排版日期")
                return false
            }
            if (!this.from.Mobile) {
                alert("请输入本人联系方式")
                return false
            }
            if (!this.from.EmergentMobile) {
                alert("请输入紧急人联系方式")
                return false
            }
            if (!this.from.ConsultCntIntroduce) {
                alert("请输入来询问题")
                return false
            }
            if (!this.from.FamilyStatus) {
                alert("请确定家庭情况")
                return false
            }
            if (!this.from.SymptomPerformance) {
                alert("请输入症状表现")
                return false
            }
            if (!this.from.PhysicalCondition) {
                alert("请输入躯体情况")
                return false
            }
            if (!this.from.ConsultingHistory) {
                alert("请输入咨询历史")
                return false
            }
            if (!this.from.PsychologicalTest) {
                alert("请输入心理测试")
                return false
            }
            if (!this.from.SymptomsOften) {
                alert("请输入症状时长")
                return false
            }
            this.$Http_Post('ConsultSubscribe/AddAppointment', { "from": this.from }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.Global.request_successful(res.Message)
                    this.dialogVisible = false
                    if (this.diandefaultZiXunShi) {
                        this.consulting(this.diandefaultZiXunShi, '');
                    } else {
                        this.consulting(this.defaultZiXunShi, '');
                    }
                } else {
                    this.Global.request_failure(res.Message)
                }
            })
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        test(i) {
            this.liActiveCalss = i;
        },
        loading(val) {
            var form = { "Name": val }
            this.$Http_Post('ConsultSubscribe/ShowZiXunShi', { "from": form }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.ZiXunShi = res.Data;
                    this.defaultZiXunShi = res.Data[0].UserID;
                    this.consulting(this.defaultZiXunShi, '');
                }
            })
        },
        consulting(val, time) {
            var from = { "UserID": val, "Dates": time }
            this.$Http_Post('ConsultSubscribe/GetConsultationAppointment', { "from": from }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.paiban = res.Data
                } else {
                }
            })
        },
        cousuo() {
            this.loading(this.taocan)
        }
    },
    mounted() {
        window.addEventListener('keydown', this.keyDown)
        this.loading('');
    },
}
</script>
<style>
.ClientConsulting {
    width: 100%;
    margin-top: 43px;
    background-color: #031924;
}

.ClientConsulting .ClientConsulting_left {
    width: 178px;
    height: 100%;
    float: left;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_top {
    height: 147px;
    background-image: url('../../assets/20220422095604.png');
    background-size: 100% 100%;
    width: 278px;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_top p {
    color: #7AE7FF;
    padding: 14px;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_top img {
    width: 120px;
    height: 80px;
    margin-left: 16px;
    margin-top: 4px;
    float: left;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_top span {
    color: #40F5FF;
    margin-top: 4px;
    margin-left: 16px;
    width: 120px;
    display: inline-block;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_top i {
    color: #6EBEC2;
    margin-top: 16px;
    margin-left: 16px;
    display: inline-block;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_botton {
    min-height: 500px;
    background-color: #0B2D3D;
    width: 278px;
    margin-top: 16px;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_botton ul::-webkit-scrollbar {
    height: 0;
    width: 0;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_botton h3 {
    color: #FFEB3B;
    font-size: 18px;
    padding: 16px;
}

.ClientConsulting .ClientConsulting_left input:focus {
    border-color: #000000 !important;
    outline: 0;
    border-width: none;
}

.ClientConsulting .ClientConsulting_left input {
    width: 247px;
    height: 50px;
    margin-top: 00px;
    background-image: url('../../assets/img_content_bg.png');
    border: none;
    border-radius: 19px;
    background-size: 100% 100%;
    text-indent: 30px;
    color: #00E6FF;
    display: inline-block;
    float: left;
    margin-left: 16px;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_botton ul li {
    width: 251px;
    height: 46px;
    margin-top: 16px;
    background-image: url('../../assets/img_bg_name.png');
    margin-left: 16px;
    line-height: 46px;
    text-align: center;
    color: #00E6FF;
}

.ClientConsulting .ClientConsulting_left .ClientConsulting_left_botton ul {
    margin-top: 70px;
    height: 440px;
    overflow: auto;
}

.ClientConsulting .ClientConsulting_right {
    width: calc(100% - 298px);
    float: right;
    height: 580px;
    margin-left: 16px;
    margin-top: 14px;
}

.ClientConsulting .ClientConsulting_right .ClientConsulting_right_top li {
    background-color: rgb(10 53 84);
    width: calc(100% / 7 - 10px);
    float: left;
    height: 56px;
    margin-top: 20px;
    border: 1px solid #00E6FF;
    margin-left: -1px;
    color: #6EBEC2;
    text-align: center;
}

.ClientConsulting .ClientConsulting_right .ClientConsulting_right_top li p {
    height: 20px;
    margin-top: 6px;
}

.ClientConsulting .ClientConsulting_right_ul {
    margin-left: -3px;
    width: 100%;
}

.ClientConsulting .ClientConsulting_right_ul>li {
    background-color: #031924;
    float: left;
    margin-top: 10px;
    width: calc(100% / 7 - 10px);
}

.ClientConsulting .ClientConsulting_right_ul>li ul {
    margin-left: 10px;
}

.ClientConsulting .ClientConsulting_right_ul>li ul li {
    margin-top: 10px;
    height: 60px;
    width: 100%;
    background-color: #0A3554;
    margin-left: 4px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    color: #6EBEC2;
    position: relative;
}

.ClientConsulting .ClientConsulting_right_ul>li ul li p {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: rgba(11, 131, 138, 1);
    color: rgba(64, 245, 255, 1);
    display: none;
}

.ClientConsulting .ClientConsulting_right_ul>li ul li i {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: rgba(11, 131, 138, 1);
    color: rgba(64, 245, 255, 1);
}

.ClientConsulting .ClientConsulting_right_ul>li ul li i:hover span {
    display: block;
}

.ClientConsulting .ClientConsulting_right_ul>li ul li i span {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: rgba(11, 131, 138, 1);
    color: rgba(64, 245, 255, 1);
    position: absolute;
    top: 0px;
    left: 0px;
    display: none;
}

.ClientConsulting .ClientConsulting_right_ul>li ul li:hover p {
    display: block;
}

.ClientConsulting .el-dialog {
    height: 580px;
    background: none;
    background-image: url('../../assets/img_Popup_bg.png');
    position: relative;
}

.ClientConsulting .el-dialog__title {
    color: rgba(77, 237, 255, 1);
    font-size: 18px;
}

.ClientConsulting .el-dialog__headerbtn .el-dialog__close {
    color: rgba(77, 237, 255, 1);
}

.ClientConsulting .ConsultCntIntroduce {
    margin-top: 10px;
    width: 480px;
    float: left;
}

.ClientConsulting .boxs {
    width: 664px;
    background: rgba(3, 17, 24, 1);
    height: 457px;
    margin-left: 2px;
    overflow: auto;
    position: relative;
}

.ClientConsulting .boxs::-webkit-scrollbar {
    height: 0;
    width: 0;
}

.ClientConsulting .boxs .el-form-item__label {
    color: rgba(64, 181, 194, 1) !important;
}

.ClientConsulting .boxs .el-radio {
    color: rgba(77, 237, 255, 1) !important;
}

.ClientConsulting .boxs .el-radio__inner::after {
    background-color: rgba(18, 59, 88, 1) !important;
}

.cscklkl {
    width: 320px;
    float: left;
    margin-top: 10px;
}

.ClientConsulting .boxs .el-form-item__content {
    margin-left: 20px !important;
}

.ClientConsulting .boxs p {
    height: 20px;
    padding: 0px;
    margin: 0px;
    color: rgba(64, 181, 194, 1) !important;
    line-height: 20px;
}

.ClientConsulting .boxs .el-form-item {
    margin-bottom: 0px;
}

.ClientConsulting .boxs .el-input {
    margin-top: 10px;
}

.ClientConsulting .boxs .el-input__inner {
    background-color: rgba(8, 43, 61, 1);
    border: none;
    color: rgba(77, 237, 255, 1);
    width: 200px;
}

.ClientConsulting .boxs input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: rgba(64, 181, 194, 1);
}

.ClientConsulting .boxs input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: rgba(64, 181, 194, 1)
}

.ClientConsulting .boxs input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba(64, 181, 194, 1)
}

.ClientConsulting .boxs input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: rgba(64, 181, 194, 1)
}

.ClientConsulting .boxs .el-icon-arrow-up:before {
    color: rgba(64, 181, 194, 1);
}

.ClientConsulting .boxs .el-icon-time:before {
    color: rgba(64, 181, 194, 1);
}

.ClientConsulting .boxs .el-icon-date:before {
    color: rgba(64, 181, 194, 1);
}

.ClientConsulting .boxs .cscklkltextarea {
    width: 500px;
    height: 80px;
    float: left;
    margin-top: 10px;
}

.ClientConsulting .boxs .zui {
    padding-bottom: 20px;
}

.ClientConsulting .boxs .el-textarea__inner {
    background-color: rgba(8, 43, 61, 1);
    color: rgba(77, 237, 255, 1);
    margin-top: 10px;
    border: none;
    resize: none;
}

/* .ClientConsulting   .el-select-dropdown{background-color: rgba(8, 43, 61, 1) !important;} */
.ClientConsulting .wbutton {
    position: absolute;
    left: 320px;
    bottom: 10px;
    width: 80px;
    height: 30px;
    background: linear-gradient(180deg, rgba(17, 103, 139, 1) 0%, rgba(21, 50, 80, 1) 100%);
    border: 1px solid rgba(166, 166, 166, 1);
    border: none;
    color: rgba(0, 230, 255, 1);
}

.el-scrollbar {
    background-color: rgba(8, 43, 61, 1);
    color: rgba(77, 237, 255, 1);
}

.el-select-dropdown__item.selected {
    color: rgba(77, 237, 255, 1);
}

.el-picker-panel {
    background-color: rgba(8, 43, 61, 1);
    color: rgba(77, 237, 255, 1);
    border: none;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: rgba(8, 43, 61, 1);
}

.el-popper[x-placement^=bottom] .popper__arrow {
    border-bottom-color: rgba(8, 43, 61, 1);
}

.el-select-dropdown {
    border: none;
}

.el-message-box {
    background-color: rgba(8, 43, 61, 1);
    color: rgba(77, 237, 255, 1);
    border: none;
    color: rgba(77, 237, 255, 1);
}
</style>

